import { render } from "./ArchiveInteractionDemo.vue?vue&type=template&id=e17bec40&scoped=true"
import script from "./ArchiveInteractionDemo.vue?vue&type=script&lang=js"
export * from "./ArchiveInteractionDemo.vue?vue&type=script&lang=js"

import "./ArchiveInteractionDemo.vue?vue&type=style&index=0&id=e17bec40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e17bec40"]])

export default __exports__